import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICidade, IEstado } from 'src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class IBGEService {
  constructor(private httpClient: HttpClient) {}
  private baseURL: string = 'https://servicodados.ibge.gov.br/api/v1';
  getEstados(orderBy: 'id' | 'sigla' | 'nome' = 'nome') {
    return this.httpClient.get<IEstado[]>(
      `${this.baseURL}/localidades/estados`,
      {
        params: new HttpParams().set('orderBy', orderBy)
      }
    );
  }
  getCidadesPorEstado(estado: string) {
    return this.httpClient.get<ICidade[]>(
      `${this.baseURL}/localidades/estados/${estado}/municipios`
    );
  }
}
